// common ui related types

import { JwtPayload } from 'jwt-decode';

export type SelectOption = {
  key: string;
  name: string;
};

export type Option = {
  key: string | number;
  name: string;
  value: number;
};

export type FullTime = {
  isActive: boolean | null;
  date?: Date;
  time?: Option;
  shortDateString?: string;
};

export enum CheckboxState {
  CHECKED = 'SELECTED',
  UNCHECKED = 'UNSELECTED',
  INDETERMINATE = 'INDETERMINATE',
}

// TODO: implement full error
export type FlybitsError = {
  error: {
    exceptionMessage: string;
  };
};

export type FBTokenClaims = JwtPayload & {
  authMethod?: string;
};
